<template>

  <el-dialog
    title="台号管理"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
  <div class="common-seach-wrap">
    <el-button size="small"  @click="addClick()">添加桌号</el-button> 
      <div class="" style="margin:10px;">点单状态：
        <el-switch
        @change="openTable"
          v-model="open_table"
          active-text="开启"
          inactive-text="关闭">
        </el-switch>
      
      </div>
      <div class="" style="margin:10px;">先下单后支付：
        <el-switch
        @change="payAfter"
          v-model="pay_after"
          active-text="开启"
          inactive-text="关闭">
        </el-switch>
      
      </div>
       <el-button @click="showDownLoad=true" size="small" >下载桌码</el-button>
      <el-dialog title="下载推广码" :visible.sync="showDownLoad"  :close-on-click-modal="false" append-to-body>
          
          <el-button size="small"  @click="downQrcode('h5')">下载普通桌码</el-button> 
          <el-button size="small"  @click="downQrcode('wx')">下载小程序码</el-button> 
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelDownLoad">取 消</el-button>
          </div>
        </el-dialog>
    
  </div>
  <div >
    
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          
          <el-table-column prop="table_num_id" label="台号ID"></el-table-column>
          <el-table-column prop="name" label="台号"></el-table-column>
          <el-table-column prop="num" label="人数"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
               <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/plus/table_num/delete'">删除</el-button>
                <el-button @click="openCode(scope.row.table_num_id)" type="text" size="small" v-auth="'/plus/table_num/show_code'">查看二维码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Add
        v-if="open_add"
        :open_add="open_add"
        :store_id="store_id"
        @closeDialog="closeDialog"
      ></Add>
      <Qrcode v-if="isshow" :is_show="isshow" :qrcode="qrcode" :code_url="code_url" :table_num_id="table_num_id" @closeDialog="closeDialogLabelFunc"></Qrcode>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import TableApi from '@/api/table_num.js';
import Add from './Add.vue';
import Qrcode from './code.vue';
import qs from 'qs';
export default {
  components: {
    Add,
    Qrcode
  },
  inject: ['reload'],
  data() {
    return {
      showDownLoad:false,
      /*是否加载完成*/
      open_table:false,
      pay_after:false,
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      /*是否打开编辑弹窗*/
      open_add: false,
      /*当前编辑的对象*/
      userModel: {},
      isshow:false,
    };
  },
  props: ["open_list", "store_id"],
  created() {
    this.dialogVisible = this.open_list;
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    cancelDownLoad(){
      this.showDownLoad = false;
    },
    downQrcode(source){
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let params = {
        store_id: this.store_id,
        source: source
      };
      this.showDownLoad = false;
      let w = window.open('about:blank');
      w.location.href = baseUrl + '/index.php/shop/plus.table_num.setting/downQrcode?' + qs.stringify(params);
    },
    openTable(event){
      console.log(event)
      let self = this;
      TableApi.updateStatus({
        store_id:self.store_id,
        status:event?1:0,
      }, true)
        .then(data => {
          self.$message({
                message: '恭喜你，设置成功',
                type: 'success'
              });
        })
        .catch(error => {});
    },
    payAfter(event){
      console.log(event)
      let self = this;
      TableApi.updateStatus({
        store_id:self.store_id,
        pay_after:event?1:0,
      }, true)
        .then(data => {
          self.$message({
                message: '恭喜你，设置成功',
                type: 'success'
              });
        })
        .catch(error => {});
    },
    handleClick(tab, event) {
        console.log(tab, event);
      },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.store_id = self.store_id;
      TableApi.getList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.open_table = data.data.manage.status
          self.pay_after = data.data.manage.pay_after
        })
        .catch(error => {});
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    },
    async closeDialog(reflush = false) {
      this.open_add = false;
      this.getTableList();
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          TableApi.delete(
            {
              table_num_id: row.table_num_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，删除成功',
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    closeDialogLabelFunc(e) {
      let self = this;
      self.isshow = false;
    
    },
      //查看推广二维码 
      openCode(table_num_id){
        let self = this;
        let form = {
          'table_num_id':table_num_id,
          'source':'h5',
        };
        self.table_num_id = table_num_id

        self.loading = true;
        TableApi.findPosterCode(form, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.isshow  = true;
            self.qrcode = data.data.qrcode;
            self.code_url = data.data.code_url
          } else {
            self.$message({
              message: '二维码生成失败',
              type: 'error'
            });
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/table_num/store/dialog/List.vue